import React from 'react';
import { Hero } from '../components/Hero';
import { SalesLetter } from '../components/SalesLetter';
import { BonusSection } from '../components/BonusSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { PricingSection } from '../components/PricingSection';
import { UpsellSection } from '../components/UpsellSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { PurchaseNotification } from '../components/PurchaseNotification';
export function SalesPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-orange-100 selection:text-orange-900" data-id="element-319">
      <header className="bg-white border-b border-slate-100 py-4 sticky top-0 z-40 shadow-sm" data-id="element-320">
        <div className="max-w-6xl mx-auto px-4 flex justify-between items-center" data-id="element-321">
          <div className="font-black text-2xl italic tracking-tighter text-blue-900" data-id="element-322">
            SIC<span className="text-orange-500" data-id="element-323">360</span>
          </div>
          <button onClick={() => document.getElementById('purchase')?.scrollIntoView({
          behavior: 'smooth'
        })} className="bg-blue-900 text-white text-sm font-bold px-4 py-2 rounded-lg hover:bg-blue-800 transition-colors" data-id="element-324">
            Comprar Ahora
          </button>
        </div>
      </header>

      <main data-id="element-325">
        <Hero data-id="element-326" />
        <SalesLetter data-id="element-327" />
        <BonusSection data-id="element-328" />
        <PricingSection data-id="element-329" />
        <UpsellSection data-id="element-330" />
        <GuaranteeSection data-id="element-331" />
        <TestimonialsSection data-id="element-332" />
        <FAQSection data-id="element-333" />
      </main>

      <footer className="bg-slate-900 text-slate-400 py-12 text-center text-sm" data-id="element-334">
        <div className="max-w-6xl mx-auto px-4" data-id="element-335">
          <p className="mb-4 font-bold text-white text-lg italic" data-id="element-336">SIC 360</p>
          <p data-id="element-337">© {new Date().getFullYear()} Todos los derechos reservados.</p>
          <p className="mt-2" data-id="element-338">Hecho con ❤️ para la docencia argentina.</p>
        </div>
      </footer>

      <PurchaseNotification data-id="element-339" />
    </div>;
}